<template>
  <div class="bg-light">
    <top-bar @clearPedidos="$emit('clearPedidos')"/>
    <div class="content pedidos" v-if="tipoExibicao === 1">
      <container-pedidos ref="cpedido"/>
    </div>
    <div class="content kanban" v-if="tipoExibicao === 2">
      <kanban-pedidos ref="kpedido"/>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../components/commons/TopBar";
  import ContainerPedidos from "../../components/gestor/ContainerPedidos";
  import VersionApp from "@/components/commons/VersionApp";
  import KanbanPedidos from "@/components/gestor/KanbanPedidos";

  export default {
    name: 'Pedidos',
    components: {KanbanPedidos, VersionApp, ContainerPedidos, TopBar},
    data() {
      return {
        tipoExibicao: null
      }
    },

    mounted() {
      if (this.$store.state.isReadOnly || this.$store.state.is_comanda) {
        this.$router.push("/home");

      } else {
        this.tipoExibicao = localStorage.getItem('modoLista') === '1' ? 1 : 2;
        this.$nextTick(() => this.abrirPedidoAlerta(this.$route.query.id));
      }
    },

    methods: {
      abrirPedidoAlerta(id) {
        if (!id) {
          return;
        }

        if (this.$refs.cpedido) {
          this.$refs.cpedido.buscarPedidoId({ id_pedido: id, buscaId: true }, () => {
            this.$refs.cpedido.aberto = true;
          });
        } else if (this.$refs.kpedido) {
          this.$refs.kpedido.abrirPedido({ id_pedido: id });
        }
      }
    },

    watch: {
      '$route.query.id'(id) {
        this.$nextTick(() => this.abrirPedidoAlerta(id));
      }
    },

    beforeRouteLeave(to, from, next) {
      if (this.is_mobile && this.$refs.cpedido && this.$refs.cpedido.aberto) {
        this.$emit("closePedido");
        next(false);

      } else {
        next()
      }
    },
  }
</script>

<style scoped>
 .content.kanban {
   position: relative;
   margin-top: 73px;
   margin-bottom: 0;
 }
</style>
